export default function isTouch() {
  /* istanbul ignore next */
  return document.documentElement.classList.contains('touchevents')
}
